import { render, staticRenderFns } from "./DiySwiper.vue?vue&type=template&id=4e114a2b&scoped=true&"
import script from "./DiySwiper.vue?vue&type=script&lang=js&"
export * from "./DiySwiper.vue?vue&type=script&lang=js&"
import style0 from "./DiySwiper.vue?vue&type=style&index=0&id=4e114a2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e114a2b",
  null
  
)

export default component.exports